import Util from '../forecast-app/shared/util/util';
import {commitMutation, graphql} from 'react-relay';

const mutation = graphql`
	mutation EnableAndConvertSubtasksForProjectMutation($input: EnableAndConvertSubtasksForProjectInput!) {
		enableAndConvertSubtasksForProject(input: $input) {
			project {
				id
				taskLevels
				remainingAutoCalculated
				useTaskHierarchy
			}
			projectEdge {
				node {
					id
					taskLevels
					remainingAutoCalculated
					useTaskHierarchy
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	return commitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
